// Contexts for the Help & session layer (spec §6).
//
// Two contexts on purpose. SessionHelpContext carries the room state and
// changes often. RegisterGameFlowContext carries one stable function, so a
// GameFlowProvider that registers itself never re-renders because a vote
// tally moved (N7).
import { createContext, useContext } from 'react';
import { GameFlowRegistryContext } from '../../contexts/gameFlowRegistry';

export const SessionHelpContext = createContext(null);
// The setter context is Lane F's (contexts/gameFlowRegistry.js); kept under
// this name too so both lanes read the same object.
export const RegisterGameFlowContext = GameFlowRegistryContext;

const noopUnregister = () => {};
const noopRegister = () => noopUnregister;

/** The room state, or null outside a SessionHelpProvider. */
export function useSessionHelp() {
  return useContext(SessionHelpContext);
}

/**
 * GameFlowProvider (Lane F) reads GameFlowRegistryContext directly and calls
 *   registerGameFlow({ applyAuthoritative, isHydrating, stepIndex })
 * in an effect. The returned function unregisters only this call's own
 * registration, so an old instance cleaning up after a newer one registered
 * cannot wipe it (NB5). Outside a provider this is a no-op.
 */
export function useRegisterGameFlow() {
  return useContext(GameFlowRegistryContext) || noopRegister;
}
